import letterhead from '@/views/mydiesel/letterheadkpdn.png'
import moment from 'moment'

export const content = (registerForm, vehicleArray, rawOilcompanyList, dateFormatted, nextMonth, displayAwamBarangan) => {
  console.log('registerForm', registerForm)
  console.log('vehicleArray', vehicleArray)

  const nowDate =  moment().format('YYYYMM')

  // AEDuo has no awam/barangan sector — every vehicle here is treated as awam, and tidak-layak /
  // road-tax-expired vehicles are already excluded by the caller, so we sum the whole array.
  const kuotaAsasAwam = Number(vehicleArray.reduce((acc, item) => {
    const value = Number(item.vehicleQuotaBase) ? Number(item.vehicleQuotaBase) : 0
    return acc + value
  }, 0))

  const kuotaTambahan = Number(vehicleArray.reduce((acc, item) => {
    const value = Number(item.vehicleQuotaAddition) ? Number(item.vehicleQuotaAddition) : 0
    return acc + value
  }, 0))

  const quotaAdditionFlag = registerForm.quotaAdditionFlag ? true : false

  const formatDate = (date, minusDays = 0) => {
    if (date) {
      return moment(date).subtract(minusDays, 'days').format('DD/MM/YYYY')
    } else {
      return ''
    }
  }

  const oilcompanyList = []

  for (var rawOilCompanyListIndex in rawOilcompanyList) {
    const rawOilcompanyListItem = rawOilcompanyList[rawOilCompanyListIndex]
    const oilcompanyListExist = oilcompanyList.find((v) => v.oilcompanyKey === rawOilcompanyListItem.oilcompanyKey)
    const oilcompanyListExistIndex = oilcompanyList.findIndex((v) => v.oilcompanyKey === rawOilcompanyListItem.oilcompanyKey)
    if (!oilcompanyListExist) {
      oilcompanyList.push(rawOilcompanyListItem)
    } else {
      const oilcompanyPercentage = Number(rawOilcompanyListItem.oilcompanyPercentage + oilcompanyListExist.oilcompanyPercentage)
      oilcompanyList[oilcompanyListExistIndex] = {
        ...oilcompanyListExist,
        oilcompanyProfileVehicleType: 'awambarangan'
      }
    }
  }

  const pageContent = []

  const postAddressSameAsMainAddress = registerForm.postAddressSameAsMainAddress ? true : false

  const postAddress1 = postAddressSameAsMainAddress ? registerForm.mainAddress1 : registerForm.postAddress1
  const postAddress2 = postAddressSameAsMainAddress ? registerForm.mainAddress2 : registerForm.postAddress2
  const postcode = postAddressSameAsMainAddress ? registerForm.mainPostcode : registerForm.postPostcode
  const town = postAddressSameAsMainAddress ? registerForm.mainTown : registerForm.postTown
  const state = postAddressSameAsMainAddress ? registerForm.mainStateLabel : registerForm.postStateLabel

  for (var oilcompanyIndex in oilcompanyList) {
    var oilcompany = oilcompanyList[oilcompanyIndex]
    const oilcompanyPercentage = oilcompany.oilcompanyPercentage
    const newKuotaAsasAwam = Number(Number(kuotaAsasAwam) * oilcompanyPercentage / 100).toLocaleString('en')
    const newKuotaTambahan = Number(Number(kuotaTambahan) * oilcompanyPercentage / 100).toLocaleString('en')
    pageContent.push(`
<div class="parent page1">
  <div class="header">
    <img id="letterhead" class="letterhead" src="${letterhead}"/>
  </div>
  <div class="content">
    <div class="pright">
      <p>Ruj. Kami: KPDN/${registerForm.userGeneralIdentificationNumber}/${nowDate}(1)</p>
      <p>Tarikh : ${dateFormatted}</p></br>
    </div>
    <p><b>${registerForm.userGeneralName ? registerForm.userGeneralName : ''}</b></p>
    <p>${postAddress1 ? postAddress1 : ''}</p>
    ${postAddress2 ? '<p>' + postAddress2 + '</p>' : ''}
    <p>${postcode ? postcode : ''} ${town ? town : ''} ${state ? state : ''}</p></br>
    <p> Tuan/Puan, </p></br>
    <p><b><u>KELAYAKAN MEMBELI DIESEL BERSUBSIDI</u></b></p><br>
    <div class="pjustify">
      <p>Merujuk kepada perkara di atas, Kerajaan telah meluluskan peruntukan diesel bersubsidi baru kepada Tuan seperti berikut:</p><br>
    </div>
    <div class="pmarginleft">
      <ol type="i">
        <li>No. SSM (No. SSM Lama) / No. Kad Pengenalan / No. PBT / SKM / Ordinan : <b><u>${registerForm.userGeneralIdentificationNumber ? registerForm.userGeneralIdentificationNumber : ''}</u></b></li><br>
        <li>No Subsidi Pemegang Akaun : <b><u>${registerForm.userGeneralSubsidyNumberDiesel ? registerForm.userGeneralSubsidyNumberDiesel : ''}</u></b></li><br>
        <li>Syarikat Minyak : <b>${oilcompany.oilcompanyName}</b></li><br>
        <li>Sektor : <b>PSDN - SYKT</b></li><br>
        <li>Amaun : <b><u>${newKuotaAsasAwam} </u></b> liter sebulan<br></li><br>
        <li>Tarikh Kuatkuasa : <b>${nextMonth}</b></li><br>
        ${quotaAdditionFlag ? `<li>Amaun Kuota Tambahan : <b><u>${newKuotaTambahan}</u></b> liter sebulan <br>` : ''}
        ${quotaAdditionFlag ? `<br>` : ''}
        ${quotaAdditionFlag ? `<li>Tarikh Kuatkuasa Kuota Tambahan : <b>${formatDate(registerForm.quotaAdditionStartDate)}</b></li><br>` : ''}
      </ol>  
    </div>
    <div class="pjustify">
      <p>2.	Sila bawa <b>Surat Kelulusan</b> dan <b>Senarai Kenderaan</b> asal ini <b><u>dengan segera </u></b>bagi mendapatkan fleetcard dari syarikat minyak yang telah dipilih. Seyogia diingatkan, <b><u>hanya pemohon yang telah mendapatkan fleetcard, layak menikmati pembelian diesel bersubsidi.</p></u></b><br>
      <p>3.	Kelulusan ini adalah tertakluk <i><b>kepada Syarat-Syarat Kelulusan Membeli Diesel Bersubsidi Menggunakan Fleetcard seperti yang telah ditetapkan.</i></b></p><br>
      <p>4.	Kelayakan kenderaan mendapat diesel bersubsidi tamat sekiranya tempoh sah laku cukai jalan tamat dan tidak diperbaharui.</p><br>
      <p>Sekian, dimaklumkan.</p><br>
      <p>Ketua Setiausaha</p>
      <p>Kementerian Perdagangan Dalam Negeri Dan <br>Kos Sara Hidup</p>
    </div>
    <div class="prightopacity">
      <span>Salinan pemohon</span>
    </div>
    <hre class="hline">
    <div class="computer">
      <span>*Surat cetakan komputer ini tidak memerlukan sebarang tandatangan</span>
    </div>
  </div>
</div>
    `)
  }
  
  /*
  // Separate awam and barangan selection
  <li>Sektor : <b>${oilcompany.oilcompanyProfileVehicleType ? oilcompany.oilcompanyProfileVehicleType === 'awam' ? 'AWAM' : oilcompany.oilcompanyProfileVehicleType === 'barangan' ? 'BARANGAN' : oilcompany.oilcompanyProfileVehicleType === 'awambarangan' ? 'AWAM DAN BARANGAN' : oilcompany.oilcompanyProfileVehicleType : ''}</b></li><br>
  ${
    displayAwamBarangan ?
    `<li>Amaun :
    ${oilcompany.oilcompanyProfileVehicleType && (oilcompany.oilcompanyProfileVehicleType === 'awam' || oilcompany.oilcompanyProfileVehicleType === 'awambarangan') ? `<b><u>${newKuotaAsasAwam} </u></b> liter sebulan (Awam) <br>` : ''}
    ${oilcompany.oilcompanyProfileVehicleType && (oilcompany.oilcompanyProfileVehicleType === 'barangan' || oilcompany.oilcompanyProfileVehicleType === 'awambarangan') ? `<b><u>${newKuotaAsasBarangan} </u></b> liter sebulan (Barangan) <br>` : ''}
    </li><br>` :
    oilcompany.oilcompanyProfileVehicleType && (oilcompany.oilcompanyProfileVehicleType === 'awam' || oilcompany.oilcompanyProfileVehicleType === 'awambarangan') ? `<li>Amaun : <b><u>${newKuotaAsasAwam} </u></b> liter sebulan (Awam) <br></li><br>` : ''
  }
  */

  return `
<!DOCTYPE html>
<html>
<head>
<style>
  @media print {
    @page {
      size: A4;
      margin: 0;
    }
    body {
      margin: 0 !important;
    }

    * {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }

  body {
    margin: 0px;
  }

  .backgroundImage {
    display: flex;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 210mm;
    z-index: -999;
  }

  .parent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow: hidden;
    width: 210mm;
    height: 297mm;
    position: relative;
    page-break-after: always;
  }

  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: visible;
    width: 159.2mm;
    height: 20mm;
    margin-top: 25.4mm;
  }

  .letterhead {
    display: flex;
    width: 159mm;
  }

  .content {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 216.2mm;
    margin-top: 10mm;
  }

  .content2 {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    overflow: visible;
    width: 159.2mm;
    height: 246.2mm;
    margin-top: 25.4mm;
  }

  p {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
  }

  .pright{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .prightopacity{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 23px;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    opacity: 0.2;
    width: 100%;
  }
  .computer{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 10px;
    font-weight: bold;
    margin-top: 2mm;
    margin-bottom: 0mm;
    text-align: right;
    opacity: 1;
    width: 100%;
  }

  .prightsmallfont{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 3mm;
    font-style: bold;
    margin-top: 0mm;
    margin-bottom: 0mm;
    text-align: right;
    width: 100%;
  }

  .pjustify {
    text-align: justify;
  }

  .pmarginleft{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 4mm;
    margin-top: 0mm;
    margin-bottom: 0mm;
    margin-left: 10px;
    line-height: 4mm;
  }

  .hline {
    width: 100%;
    height: 2px;
    border-top: 1px black solid;
  }

  /* dev colors */
  .page1 {
  }
  .page2 {
  }
</style>
</head>
<body>
  ${pageContent.join('')}
</body>
</html>`
}
export default {
  content
}


// WEBPACK FOOTER //
// ./src/views/mydiesel/suratkelulusanawam_aeduo.js